module.exports = __webpack_public_path__ + "static/media/tabs-icon-03.155aa6da.svg";